import { useEffect, useState } from "react";
import { useTaskPolling } from "../../fnx/useTaskPolling";
import { convertedQuoteRouteOf, runOutcomeOf } from "./legacyConversion.rules";
import { useLegacyConversion } from "./useLegacyConversion";
var errorMessageOf = function (error) {
    var _a;
    return error && typeof error === "object" && "message" in error
        ? String((_a = error.message) !== null && _a !== void 0 ? _a : "")
        : "";
};
export var useLegacyConversionRun = function (requestKey) {
    var conversion = useLegacyConversion(requestKey);
    var _a = useState(null), taskId = _a[0], setTaskId = _a[1];
    var _b = useState(null), outcome = _b[0], setOutcome = _b[1];
    var polling = useTaskPolling(taskId);
    useEffect(function () {
        var current = conversion.outcome;
        if (!current)
            return;
        conversion.clear();
        if (current.kind === "queued") {
            setTaskId(current.taskId);
            return;
        }
        setOutcome(runOutcomeOf(current));
    }, [conversion.outcome]);
    useEffect(function () {
        var _a;
        if (!taskId || !polling.isTerminal)
            return;
        setOutcome(polling.status === "COMPLETED"
            ? { kind: "completed", route: convertedQuoteRouteOf(polling.result) }
            : { kind: "taskFailed", message: errorMessageOf((_a = polling.task) === null || _a === void 0 ? void 0 : _a.error) });
        setTaskId(null);
    }, [taskId, polling.isTerminal, polling.status]);
    var start = function (code) {
        if (!code || taskId || conversion.loading)
            return;
        setOutcome(null);
        conversion.convertOne(code);
    };
    return {
        start: start,
        running: conversion.loading || Boolean(taskId),
        outcome: outcome,
        clearOutcome: function () { return setOutcome(null); },
    };
};
